import React from 'react';

const Participant = (props) => {
  return (
    <td className={'participant ' + (props.tdClass ?? '')} xs={4} style={{ verticalAlign: 'middle', visibility: props.visible ? 'visible' : 'hidden' }}>
      <img alt='Flag' style={{ width: "26px", marginRight: "0.4em" }} align={"middle"} src={props.flagUrl} />
      {props.title}
    </td>
  );
};

export default Participant;
